import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DialogComponent } from '@/shared/ui-components/dialog/dialog.component';
import { AskQuestionFormComponent } from '../ask-question-form/ask-question-form.component';

/**
 * Dialog chrome around `AskQuestionFormComponent`.
 *
 * The form is guarded on `visible` rather than reset on close: it is projected through
 * `app-dialog`'s `ng-content`, so PrimeNG only hides its container and the instance would
 * otherwise live for the lifetime of the page, carrying its draft and validation state
 * into the next open.
 */
@Component({
    selector: 'app-ask-question-dialog',
    standalone: true,
    imports: [CommonModule, TranslateModule, DialogComponent, AskQuestionFormComponent],
    templateUrl: './ask-question-dialog.component.html'
})
export class AskQuestionDialogComponent {
    @Input() public visible = false;

    @Output() public visibleChange = new EventEmitter<boolean>();
    @Output() public submitted = new EventEmitter<void>();

    public onVisibleChange(value: boolean): void {
        this.visibleChange.emit(value);
    }

    public close(): void {
        this.visibleChange.emit(false);
    }

    public onSubmitted(): void {
        this.visibleChange.emit(false);
        this.submitted.emit();
    }
}
